import React from 'react';

const FeedbackPriority = ({priority}) =>{
    let className = priority;
    switch(priority){
        case "low_priority":
            className += ' fa-minus-square ';
            break;
        case "high_priority":
            className += ' fa-plus-square ';
            break;
        case "medium_priority":
            className += ' fa-square ';
    }
    return <span><i className={'fa ' + className} /></span>;
};

export default FeedbackPriority;